import { imageNames } from "@/src/constants/imageConstants.js";

export const signalTabs = {
  MANAGE_SIGNALS: "configure",
  SIGNAL_STREAM: "signal_stream",
};

export const signalHeaders = [
  { label: "Signal Name", key: "name", width: 3 },
  { label: "Status", key: "status", width: 2 },
  { label: "Signal Type", key: "type", width: 3 },
  { label: "Created on", key: "created_at", width: 2 },
  { label: "Last Updated", key: "updated_at", width: 2 },
];

export const signalStages = [
  { key: "CREATE", name: "Create" },
  { key: "CONFIGURE", name: "Configure" },
  { key: "DISTRIBUTE", name: "Distribute Leads" },
];

export const baseSignalStages = {
  CREATE: "CREATE",
  CONFIGURE: "CONFIGURE",
  DISTRIBUTE: "DISTRIBUTE",
};

export const COMPANY_SIGNALS_ICP_FILTER = ['job_posting_by_company', 'new_funding_announcement', 'company_mentioned_in_news'];

export const signalTypes = [
  {
    label: "Post from thought leaders",
    key: "thought_leader_post_reacters",
    description: "Monitor LinkedIn post interactions with content from thought leaders",
    hidden: true,
    modalContent: {
      title: "Post from Thought Leaders",
      aboutSignal: "Track when someone engages with LinkedIn Posts from industry thought leaders or influencers in your niche.",
      howThisWillHelp: "If someone interacts with a LinkedIn post of CEO of your competitor product — they might be looking for a tool like yours.",
      howItWorks: [
        "Add URLs of relevant thought leader LinkedIn profiles",
        "SuperAGI monitors engagement from your ideal customer persona",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Profile LinkedIn URL",
    type_label: "Post from thought leaders",
    configDescription: "",
    linkedin_url_tooltip: "Add LinkedIn URLs of people.",
  },
  {
    label: "Post from target company",
    key: "target_company_post_reactors",
    description: "Monitor LinkedIn post interactions with target competitors in your space",
    hidden: true,
    modalContent: {
      title: "Post from Target Company",
      aboutSignal: "Monitor when someone engages with LinkedIn posts from your direct competitors — a strong signal they're in buying mode.",
      howThisWillHelp: "Let's say your competitor posts about a product update — track who's liking or commenting on it. These people might be evaluating your space.",
      howItWorks: [
        "Add the LinkedIn URL of the target company",
        "SuperAGI tracks who interacts with their posts",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Company LinkedIn URL",
    type_label: "Post from target company",
    configDescription: "",
    linkedin_url_tooltip: "Add LinkedIn URLs of companies.",
  },
  {
    label: "Posts mentioning specific keywords",
    key: "posts_with_specific_keywords",
    description: "Monitor LinkedIn post interactions with posts containing specific keywords",
    hidden: true,
    modalContent: {
      title: "Posts Mentioning Specific Keywords",
      aboutSignal: "Get notified when someone interacts with LinkedIn posts that mention keywords related to your product, service, or pain points.",
      howThisWillHelp: "You're a cybersecurity tool. You track mentions of \"data breach,\" \"SOC 2,\" or \"endpoint security\" to catch leads actively discussing security issues.",
      howItWorks: [
        "Define the keywords you want to track",
        "SuperAGI scans LinkedIn for post engagement around those topics and creates leads accordingly",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Keywords",
    type_label: "Posts mentioning specific keywords",
    configDescription: "",
    keywords_tooltip: "Enter keywords related to your product, service, or pain points.",
  },
  {
    label: "Recent job changes",
    key: "person_starting_new_position",
    description: "Track when someone changes jobs across companies, industries, and roles",
    hidden: true,
    modalContent: {
      title: "Recent Job Changes",
      aboutSignal: "Track when your ideal customers change jobs — a key buying signal that opens new opportunities and refreshes existing relationships.",
      howThisWillHelp: "When a decision-maker joins a new company, they often evaluate and change their tech stack. Reach out early to position yourself as their go-to solution.",
      howItWorks: [
        "Define your ideal customer profile with industry and role filters",
        "SuperAGI monitors job changes and creates leads automatically",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Job Change Filters",
    type_label: "Recent job changes",
    configDescription: "Define the job change criteria to track ideal customers transitioning to new roles.",
  },
  {
    label: "Job Posting by company",
    key: "job_posting_by_company",
    description: "Track when specific companies open job posting",
    hidden: true,
    modalContent: {
      title: "Job Posting by Company",
      aboutSignal: "Track when target companies post new job openings that might indicate growth or new initiatives.",
      howThisWillHelp: "Job postings often signal company growth, new projects, or budget availability. Great timing for outreach.",
      howItWorks: [
        "Add LinkedIn URLs of target companies to monitor",
        "SuperAGI tracks job postings and creates leads automatically",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Company LinkedIn URL",
    type_label: "Job Posting by company",
    configDescription: "",
    linkedin_url_tooltip: "Add LinkedIn URLs of companies.",
  },
  {
    label: "New Funding Announcement",
    key: "new_funding_announcement",
    description: "Track companies that have recently raised funding across different industries and locations",
    hidden: true,
    modalContent: {
      title: "New Funding Announcement",
      aboutSignal: "Track when companies raise fresh capital or announce new funding rounds.",
      howThisWillHelp: "Funding often sparks growth, new partnerships, and budget availability — the perfect time to reach out.",
      howItWorks: [
        "Add LinkedIn URLs of target companies to monitor",
        "SuperAGI tracks funding announcements and creates leads automatically",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Company LinkedIn URL",
    type_label: "New Funding Announcement",
    configDescription: "",
    linkedin_url_tooltip: "Add LinkedIn URLs of companies.",
  },
  {
    label: "New Funding Announcement",
    key: "latest_funding_announcement",
    description: "Track when companies announce new funding rounds or raise capital",
    modalContent: {
      title: "New Funding Announcement",
      aboutSignal: "Track when companies raise fresh capital or announce new funding rounds.",
      howThisWillHelp: "Funding often sparks growth, new partnerships, and budget availability — the perfect time to reach out.",
      howItWorks: [
        "SuperAGI automatically monitors funding announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "New Funding Announcement",
  },
  {
    label: "New Product Launch",
    key: "new_product_launch",
    description: "Track when companies launch new products or services",
    modalContent: {
      title: "New Product Launch",
      aboutSignal: "Track when companies launch new products, features, or services.",
      howThisWillHelp: "Product launches signal innovation and growth — an ideal time to offer complementary solutions or partnerships.",
      howItWorks: [
        "SuperAGI automatically monitors product launch announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "New Product Launch",
  },
  {
    label: "Acquisition News",
    key: "acquisition_news",
    description: "Track when companies announce acquisitions or get acquired",
    modalContent: {
      title: "Acquisition News",
      aboutSignal: "Track when companies make acquisitions or are acquired by other organizations.",
      howThisWillHelp: "Acquisitions often trigger infrastructure changes, integration needs, and new buying decisions — perfect timing for outreach.",
      howItWorks: [
        "SuperAGI automatically monitors acquisition announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "Acquisition News",
  },
  {
    label: "Awards & Recognitions",
    key: "awards_and_recognitions",
    description: "Track when companies receive awards or industry recognition",
    modalContent: {
      title: "Awards & Recognitions",
      aboutSignal: "Track when companies receive awards, certifications, or industry recognition.",
      howThisWillHelp: "Awards signal success and momentum — a great conversation starter and opportunity to engage with growing companies.",
      howItWorks: [
        "SuperAGI automatically monitors award announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "Awards & Recognitions",
  },
  {
    label: "New Partnership Announcement",
    key: "new_partnership_announcement",
    description: "Track when companies announce new partnerships or collaborations",
    modalContent: {
      title: "New Partnership Announcement",
      aboutSignal: "Track when companies announce strategic partnerships, collaborations, or alliances.",
      howThisWillHelp: "Partnerships signal expansion and new initiatives — an opportunity to position your solution as they scale.",
      howItWorks: [
        "SuperAGI automatically monitors partnership announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "New Partnership Announcement",
  },
  {
    label: "Layoffs",
    key: "company_layoffs",
    description: "Track when companies announce layoffs or workforce reductions",
    modalContent: {
      title: "Layoffs",
      aboutSignal: "Track when companies announce layoffs, downsizing, or workforce reductions.",
      howThisWillHelp: "Layoffs may signal cost optimization focus — an opportunity to offer cost-effective solutions or efficiency tools.",
      howItWorks: [
        "SuperAGI automatically monitors layoff announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "Layoffs",
  },
  {
    label: "Office Expansion",
    key: "office_expansion",
    description: "Track when companies expand to new locations or open new offices",
    modalContent: {
      title: "Office Expansion",
      aboutSignal: "Track when companies expand to new locations, open new offices, or enter new markets.",
      howThisWillHelp: "Office expansion signals growth and infrastructure needs — perfect timing to offer your solutions for scaling teams.",
      howItWorks: [
        "SuperAGI automatically monitors office expansion announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "Office Expansion",
  },
  {
    label: "Key Hire",
    key: "key_hire_announcement",
    description: "Track when companies make important leadership or executive hires",
    modalContent: {
      title: "Key Hire",
      aboutSignal: "Track when companies announce key hires in leadership, executive, or strategic positions.",
      howThisWillHelp: "New leaders often bring fresh perspectives and buying decisions — an ideal time to introduce your solution.",
      howItWorks: [
        "SuperAGI automatically monitors key hire announcements",
        "Use the search box to filter and find relevant leads",
        "Choose how do you want to distribute your leads"
      ]
    },
    type_label: "Key Hire",
  },
  {
    label: "Company mentioned in news",
    key: "company_mentioned_in_news",
    description: "Track when target accounts are getting news coverage",
    hidden: true,
    modalContent: {
      title: "Company mentioned in news",
      aboutSignal: "Track when your target accounts appear in news articles, press releases, or media coverage.",
      howThisWillHelp: "News coverage often signals momentum, expansion, or a major shift worth acting on. Perfect timing to reach out.",
      howItWorks: [
        "Add LinkedIn URLs of target companies to monitor",
        "SuperAGI tracks news mentions and creates leads automatically",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Company LinkedIn URL",
    type_label: "Company mentioned in news",
    configDescription: "",
    linkedin_url_tooltip: "Add LinkedIn URLs of companies.",
  },
  {
    label: "Keywords mentioned in news",
    key: "keywords_based_news",
    description: "Track when target keywords are getting news coverage",
    modalContent: {
      title: "Keywords mentioned in news",
      aboutSignal: "Track when specific keywords related to your product, service, or industry appear in news articles or press coverage.",
      howThisWillHelp: "News coverage of relevant keywords often signals market trends, opportunities, or conversations worth joining. Perfect timing to engage with prospects discussing these topics.",
      howItWorks: [
        "Define the keywords you want to track in news articles",
        "SuperAGI monitors news coverage and creates leads automatically",
        "Choose how do you want to distribute your leads"
      ]
    },
    title: "Target Keywords",
    type_label: "Keywords mentioned in news",
    configDescription: "Enter keywords related to your product, service, or industry pain points.",
    keywords_tooltip: "Enter keywords related to your product, service, or industry pain points.",
  }
];

export const getSignalTypeByKey = (key) => {
  return signalTypes.find(type => type.key === key) || null;
};

export const commonDateOptions = [
  { id: "today", name: "Today" },
  { id: "yesterday", name: "Yesterday" },
  { id: "last_3_days", name: "Last 3 days" },
  { id: "last_7_days", name: "Last 7 days" },
  { id: "last_30_days", name: "Last 30 days" },
  { id: "custom", name: "Custom" },
];

export const signalStrengthOptions = [
  { id: "high", name: "High" },
  { id: "medium", name: "Medium" },
  { id: "low", name: "Low" },
];

export const signalsPriorityImage = {
  LOW: imageNames.SIGNALS_LOW,
  MEDIUM: imageNames.SIGNALS_MEDIUM,
  HIGH: imageNames.SIGNALS_HIGH,
};

export const distributionTypeOptions = [
  {
    id: "specific_team_member",
    title: "Specific Team Member",
    description:
      "Choose a team member to manage the leads generated by this signal",
    icon: imageNames.USER,
    alt: "one_on_one_icon",
  },
  {
    id: "round_robin",
    title: "Round Robin",
    description: "Distribute leads from this signal evenly among team members",
    icon: imageNames.ROUND_ROBIN_GREY,
    alt: "round_robin_icon",
  },
];

export const linkedinReactions = {
  LIKE: { emoji: "👍", text: "Like" },
  LOVE: { emoji: "❤️", text: "Love" },
  INSIGHTFUL: { emoji: "💡", text: "Insightful" },
  FUNNY: { emoji: "😂", text: "Funny" },
  SUPPORT: { emoji: "🙌", text: "Support" },
  CELEBRATE: { emoji: "🎉", text: "Celebrate" },
  EMPATHY: { emoji: "💙", text: "Empathy" },
};
